import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CallService } from 'src/app/services/http/call/call.service';
import { Personne, PersonneSocietes, SavSuivi } from 'src/app/model/suiviCall/suiviCall';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Call, CallGmao, Tab } from 'src/app/model/call/call.model';
import { ContratSav, Installation } from 'src/app/model/installation/installation.model';
import { UtilsService } from 'src/app/services/tools/utils.service';



@Component({
  selector: 'app-call',
  templateUrl: './call.component.html',
  styleUrls: ['./call.component.scss']
})
export class CallComponent implements OnInit {

  @Input() suiviId ?: number;

  @Output() editCall = new EventEmitter<Tab>();

  constructor(
    private service: CallService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private utilsService: UtilsService
  ) { }

  public detailAppel !: SavSuivi;
  public appel !: Call;
  public name !: Personne;
  public societe !: PersonneSocietes;
  public contrat !: ContratSav;
  public callId !: string;
  public callGmao !: CallGmao;

  ngOnInit(): void {
    if(this.suiviId){
      this.callId = this.suiviId.toString();
    }else{
    const params = this.activatedRoute.snapshot.params;
    this.callId = params.id;}
    this.service.getCallsDetailsData((this.callId)).subscribe((detailAppel) => {
      this.detailAppel = detailAppel;

      this.service.getNameOwnerData(detailAppel.id_appelant).subscribe((name) => {
        this.name = name;
      })
      this.service.getContratSav((detailAppel.id_installation).toString()).subscribe((contrat) => {
        this.contrat = contrat;
      })
    })
    this.getCallState();
  }

  public submitValidation(isOk: boolean) {
    if (!this.callGmao) {
      this.callGmao = new CallGmao;
    }
    this.callGmao.call_state = isOk;
    this.callGmao.call_id = Number(this.callId);
    this.service.postValidation(this.callGmao).subscribe((validation) => {
      console.log(validation)
      this.getCallState();
    }
    )

  }

  public getCallState() {
    this.service.getCallStateData((this.callId)).subscribe((callState) => {
      if (callState[0]) {
        this.callGmao = callState[0];
        this.callGmao.new = false;
      }

    })
  }

  /** Format pretty dates */
  getNiceDate(toFormat: string): string {
    return this.utilsService.getNiceDateHeure(toFormat);
  }

  /** Go to rapport form to modify current call */
  modifyCall(){
    this.editCall.emit({id_suivi:Number(this.callId),title:this.detailAppel.nom_installation,mode:'edit'});
  }

}
